import {
    LOGIN_USER,
    LOGOUT_USER,
    STORE_SEARCH,
    CLEAR_STORE_SEARCH,
    REQUEST_ADD_INDIVIDUAL_PENDING,
    REQUEST_ADD_INDIVIDUAL_SUCCESS,
    REQUEST_ADD_INDIVIDUAL_CLEAR
} from "../actiontypes";

// * DETERMINE LOGGED IN STATUS
let cpeManagerExists = false;
let cpeOverrideStatus = false;

if (window.parent.App) {
    const userAccountPermissions =
        window.parent.App.HomeModule.models.sysProfileModel.attributes
            .userAccountPermissions;

    const cpeManagerButtonIdx = userAccountPermissions.findIndex(
        el => el.ResourceName === "CPE Manager Button"
    );
    const cpeOverrideIdx = userAccountPermissions.findIndex(
        el => el.ResourceName === "CPE Override"
    );

    cpeManagerExists = userAccountPermissions[cpeManagerButtonIdx].value === 1;
    cpeOverrideStatus = userAccountPermissions[cpeOverrideIdx].value === 1;
}

const INITIAL_STATE = {
    loggedIn: cpeManagerExists ? true : null,
    user: {
        uname: "",
        overrideEnabled: cpeManagerExists && cpeOverrideStatus ? 1 : null,
        userId: null,
        sessionId: cpeManagerExists
            ? window.parent.App.session.SessionId
            : null, // "A9C0639A-286B-4A47-8789-EF41D8899A3A"
        companyId: cpeManagerExists
            ? window.parent.App.session.companies[0].company_id
            : null // 1
    },
    lastSearches: {},
    editActions: {
        addIndividualState: null, // PENDING || SUCCESS || FAILED
        addBatchState: null
    }
};

/* UserReducer => LOGIN_USER - Adds Authenticated User Data */
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LOGIN_USER:
            return {
                ...state,
                loggedIn: action.payload.loggedIn,
                user: action.payload.user
            };
        case LOGOUT_USER:
            return {
                ...state, // ...INITIAL_STATE - Should just be this initial state
                ...{
                    loggedIn: false,
                    user: {
                        uname: "",
                        overrideEnabled: null,
                        userId: null
                    },
                    lastSearches: {},
                    editActions: {
                        addIndividualState: null,
                        addBatchState: null
                    }
                }
            };
        case STORE_SEARCH:
            return {
                ...state,
                lastSearches: action.payload
            };
        case CLEAR_STORE_SEARCH:
            return {
                ...state,
                lastSearches: {}
            };
        case REQUEST_ADD_INDIVIDUAL_PENDING:
            return {
                ...state,
                editActions: {
                    ...state.editActions,
                    addIndividualState: "PENDING"
                }
            };
        case REQUEST_ADD_INDIVIDUAL_SUCCESS:
            return {
                ...state,
                editActions: {
                    ...state.editActions,
                    addIndividualState: "SUCCESS"
                }
            };
        case REQUEST_ADD_INDIVIDUAL_CLEAR:
            return {
                ...state,
                editActions: {
                    ...state.editActions,
                    addIndividualState: null
                }
            };
        default:
            return state;
    }
};
